/******************************************
	Header
******************************************/

// Hide/Show on Scroll

jQuery(document).ready(function() {	
		
	var position = jQuery(window).scrollTop();
	var breakpoint = 1;
	
	jQuery(window).on('load scroll', function() {
		
		position = jQuery(window).scrollTop()
		
		// Fix Header
			
		if (position > breakpoint) {
			jQuery('.header').addClass('header--fixed');
		} else {
			jQuery('.header').removeClass('header--fixed');
		}
	});
	
	if (position > breakpoint) {
		jQuery('.header').addClass('header--fixed');
	}
});



// Hide Language Banner

jQuery('.header__lang-banner__accept, .header__lang-banner__decline').on('click', function() {
	jQuery('.header__lang-banner').slideUp();
	//localStorage.setItem('lang-banner', 'hidden');
	setCookie('lang-banner', 'hidden', 1);
});



/******************************************
	Nav
******************************************/

//  Burger

jQuery(document).ready(function() {
	jQuery('.burger, .nav-overlay').on('click', function() {
		jQuery('html').toggleClass('nav-open');
		jQuery('.burger').toggleClass('burger--active');
		jQuery('.main-nav').toggleClass('main-nav--show');
	}); 
});



// Toggle Main Nav Level 1

jQuery(document).ready(function() {
		
	// Toggle nav when clicked on nav link
	
	jQuery('.main-nav__item--top-level.main-nav__item--has-children > .main-nav__link').on('click', function(e) {
		e.stopPropagation();
		
		if (!jQuery(this).parent().hasClass('main-nav__item--open')) {
			jQuery(this).parent().addClass('main-nav__item--open');
			jQuery(this).parent().attr('aria-expanded', 'true');
		} else {
			jQuery(this).parent().removeClass('main-nav__item--open');
			jQuery(this).parent().attr('aria-expanded', 'false');
		}
	}); 

	// (Removed: auto-open of current-menu-item on mobile — dropdown should only open on user click)
	
	// Hide nav when clicked on body

	jQuery(document).mouseup(function(e) {
		if (window.matchMedia('(min-width: 992px)').matches) {
			var container = jQuery('.main-nav__item--open, .main-nav__item--open *');

			if (!container.is(e.target) && container.has(e.target).length === 0) {
				container.removeClass('main-nav__item--open');
			}
		}
	});

});



// Close mobile nav when an actual link in the nav is clicked
// (own ready block so it runs even if a previous handler throws)

jQuery(document).ready(function() {
	jQuery(document).on('click', '.main-nav a[href]', function() {
		jQuery('.main-nav__item--open')
			.removeClass('main-nav__item--open')
			.attr('aria-expanded', 'false');

		jQuery(this).trigger('blur');

		if (window.matchMedia('(max-width: 991.98px)').matches) {
			jQuery('html').removeClass('nav-open');
			jQuery('.main-nav').removeClass('main-nav--show');
			jQuery('.burger').removeClass('burger--active');
		}
	});
});



/******************************************
	Mobile Nav: Active Anchor + Auto-Open Submenu
******************************************/

jQuery(document).ready(function ($) {
	var $nav    = $('.main-nav');
	var $burger = $('.burger');
	if (!$nav.length) return;

	// Collect anchor links in the nav that point to a section on the CURRENT page.
	// Also strip WP "current-*" classes from same-page anchor items: WordPress sets
	// these based on URL path only and ignores the hash, so every #anchor item on
	// the active page gets flagged as current — we only want the truly active one.
	var sections = [];
	$nav.find('a[href]').each(function () {
		try {
			var url = new URL(this.href, location.origin);
			if (url.pathname !== location.pathname) return;
			if (!url.hash) return;
			var target = document.querySelector(url.hash);
			if (!target) return;

			sections.push({ link: this, target: target });

			$(this)
				.closest('.main-nav__item')
				.removeClass('current-menu-item current-menu-parent current_page_item current-menu-ancestor');
		} catch (e) {}
	});

	function setActiveAnchor() {
		if (!sections.length) return;
		var threshold = window.scrollY + window.innerHeight / 3;
		var activeLink = null;

		sections.forEach(function (s) {
			var top = s.target.getBoundingClientRect().top + window.scrollY;
			if (top <= threshold) activeLink = s.link;
		});

		$nav.find('.main-nav__item--current-anchor').removeClass('main-nav__item--current-anchor');
		if (activeLink) {
			$(activeLink).closest('.main-nav__item').addClass('main-nav__item--current-anchor');
		}
	}

	// Auto-open the top-level dropdown that contains the active sub-item — mobile only
	function autoOpenActiveDropdown() {
		if (!window.matchMedia('(max-width: 991.98px)').matches) return;

		var $activeSub = $nav.find(
			'.main-nav__item--sub.current-menu-item, ' +
			'.main-nav__item--sub.current-menu-parent, ' +
			'.main-nav__item--sub.current_page_item, ' +
			'.main-nav__item--sub.main-nav__item--current-anchor'
		);
		if (!$activeSub.length) return;

		$activeSub
			.closest('.main-nav__item--top-level.main-nav__item--has-children')
			.addClass('main-nav__item--open')
			.attr('aria-expanded', 'true');
	}

	setActiveAnchor();

	var scrollTimer;
	$(window).on('scroll', function () {
		clearTimeout(scrollTimer);
		scrollTimer = setTimeout(setActiveAnchor, 50);
	});

	// On burger click: refresh active state and auto-open the relevant dropdown
	$burger.on('click', function () {
		setTimeout(function () {
			if ($('html').hasClass('nav-open')) {
				setActiveAnchor();
				autoOpenActiveDropdown();
			}
		}, 10);
	});
});



/******************************************
	Function 'If Element is in Viewport'
******************************************/

// jQuery.fn.isInViewport = function() {
// 	var elementTop = jQuery(this).offset().top;
// 	var elementBottom = elementTop + jQuery(this).outerHeight();

// 	var viewportTop = jQuery(window).scrollTop();
// 	var viewportBottom = viewportTop + jQuery(window).height();

// 	return elementBottom > viewportTop && elementTop < viewportBottom;
// };



/******************************************
	Animate on Scroll
******************************************/

// Init AoS

jQuery(window).bind('load', function(){
	AOS.init({
		disable: false, // accepts following values: 'phone', 'tablet', 'mobile', boolean, expression or function
		startEvent: 'DOMContentLoaded', // name of the event dispatched on the document, that AOS should initialize on
		initClassName: 'aos-init', // class applied after initialization
		animatedClassName: 'aos-animate', // class applied on animation
		useClassNames: false, // if true, will add content of `data-aos` as classes on scroll
		disableMutationObserver: false, // disables automatic mutations' detections (advanced)
		debounceDelay: 50, // the delay on debounce used while resizing window (advanced)
		throttleDelay: 99, // the delay on throttle used while scrolling the page (advanced)
		
		// Settings that can be overridden on per-element basis, by `data-aos-*` attributes:
		offset: 0, // offset (in px) from the original trigger point
		delay: 50, // values from 0 to 3000, with step 50ms
		duration: 1000, // values from 0 to 3000, with step 50ms
		easing: 'ease-out-cubic', // default easing for AOS animations
		once: true, // whether animation should happen only once - while scrolling down
		mirror: false, // whether elements should animate out while scrolling past them
		anchorPlacement: 'top-bottom', // defines which position of the element regarding to window should trigger the animation
	});
}); 



/******************************************
	Show/Hide Side Buttons on Scroll
******************************************/

var position = jQuery(window).scrollTop();
var breakpoint = jQuery(window).height() / 2;

jQuery(window).on('load scroll', function() {
	var scroll = jQuery(window).scrollTop();

	if (scroll > position && position > breakpoint) {
		jQuery('.side-buttons').removeClass('side-buttons--in');
		//console.log('out');
	} else {
		jQuery('.side-buttons').addClass('side-buttons--in');
		//console.log('in');
	}

	position = scroll;
});



/******************************************
	Hero Video Controls
******************************************/

jQuery(document).ready(function () {
	var HIDE_DELAY = 2000; // ms of inactivity before controls fade out

	function getFullscreenElement() {
		return document.fullscreenElement
			|| document.webkitFullscreenElement
			|| document.msFullscreenElement;
	}

	document.querySelectorAll('.hero__video--controllable').forEach(function (wrap) {
		var video = wrap.querySelector('video');
		if (!video) return;

		var btnRestart    = wrap.querySelector('.hero__video-btn--restart');
		var btnPlayPause  = wrap.querySelector('.hero__video-btn--playpause');
		var btnFullscreen = wrap.querySelector('.hero__video-btn--fullscreen');

		var hideTimer = null;
		var isTouch   = window.matchMedia('(hover: none)').matches;

		function syncPlayPauseState() {
			if (video.paused) {
				wrap.classList.add('hero__video--paused');
				if (btnPlayPause) btnPlayPause.setAttribute('aria-label', btnPlayPause.dataset.labelPlay || 'Play');
			} else {
				wrap.classList.remove('hero__video--paused');
				if (btnPlayPause) btnPlayPause.setAttribute('aria-label', btnPlayPause.dataset.labelPause || 'Pause');
			}
		}

		function showControls() {
			wrap.classList.add('hero__video--show-controls');
			if (hideTimer) clearTimeout(hideTimer);
			hideTimer = setTimeout(hideControls, HIDE_DELAY);
		}

		function hideControls() {
			if (hideTimer) clearTimeout(hideTimer);
			hideTimer = null;
			wrap.classList.remove('hero__video--show-controls');
		}

		video.addEventListener('play',  syncPlayPauseState);
		video.addEventListener('pause', syncPlayPauseState);
		syncPlayPauseState();

		if (btnRestart) {
			btnRestart.addEventListener('click', function (e) {
				e.stopPropagation();
				video.currentTime = 0;
				video.play();
				showControls(); // refresh inactivity timer
			});
		}

		if (btnPlayPause) {
			btnPlayPause.addEventListener('click', function (e) {
				e.stopPropagation();
				if (video.paused) video.play();
				else video.pause();
				showControls();
			});
		}

		if (btnFullscreen) {
			btnFullscreen.addEventListener('click', function (e) {
				e.stopPropagation();
				if (getFullscreenElement()) {
					if      (document.exitFullscreen)       document.exitFullscreen();
					else if (document.webkitExitFullscreen) document.webkitExitFullscreen();
					else if (document.msExitFullscreen)     document.msExitFullscreen();
				} else {
					if      (wrap.requestFullscreen)       wrap.requestFullscreen();
					else if (wrap.webkitRequestFullscreen) wrap.webkitRequestFullscreen();
					else if (wrap.msRequestFullscreen)     wrap.msRequestFullscreen();
					else if (video.webkitEnterFullscreen)  video.webkitEnterFullscreen(); // iOS Safari
				}
				showControls();
			});
		}

		if (!isTouch) {
			/* Desktop: mouse activity drives visibility */
			wrap.addEventListener('mouseenter', showControls);
			wrap.addEventListener('mousemove',  showControls);
			wrap.addEventListener('mouseleave', hideControls);
		} else {
			/* Touch: tap video toggles controls; button taps refresh the timer */
			wrap.addEventListener('click', function (e) {
				if (e.target.closest('.hero__video-btn')) {
					showControls();
					return;
				}
				if (wrap.classList.contains('hero__video--show-controls')) hideControls();
				else showControls();
			});
		}
	});
});